import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { FileUploadI, UploadI } from '../_models/uploads';
import { UploadObjectI } from '../_models/uploads';
import { UploadFile } from '../_models/upload_files';
import { DraftsI } from '../_models/projects';

@Injectable({
  providedIn: 'root'
})
export class UploadService {
  subject = new Subject<string>();
  constructor(private http: HttpClient) {
  }

  getUploadForObject(projectid: number, objectid: number): Observable<UploadI[]> {
    return this.http.get<UploadI[]>(environment.apiUrl + `/projects/${projectid}/objects/${objectid}/uploads`);
  }
  postNewUpload(projectid: number, objectid: number): Observable<UploadObjectI> {
    return this.http.post<UploadObjectI>(environment.apiUrl + `/projects/${projectid}/objects/${objectid}/uploads`, {});
  }
  updateUpload(projectid: number, objectid: number, payload: any): Observable<UploadObjectI> {
    return this.http.put<UploadObjectI>(environment.apiUrl + `/projects/${projectid}/objects/${objectid}/uploads`, payload);
  }
  postFiles(uploadId: number, payload: any): Observable<FileUploadI> {
    return this.http.post<FileUploadI>(environment.apiUrl + `/uploads/${uploadId}/files`, payload);
  }
  removeFiles(uploadId: number, fileid: number): Observable<FileUploadI> {
    return this.http.delete<FileUploadI>(environment.apiUrl + `/uploads/${uploadId}/files/${fileid}`);
  }
  getLatestUploads(): Observable<UploadObjectI[]> {
    return this.http.get<UploadObjectI[]>(environment.apiUrl + `/uploads/latest`);
  }
  getDetails(projectid: number, objectid: number, uploadid: number): Observable<UploadObjectI[]> {
    return this.http.get<UploadObjectI[]>(environment.apiUrl + `/projects/${projectid}/objects/${objectid}/uploads/${uploadid}`);
  }
  getUploadedFiles(uploadid: number): Observable<UploadFile[]> {
    return this.http.get<UploadFile[]>(environment.apiUrl + `/uploads/${uploadid}/files`);
  }
  acknowledge(upload_id: number, file_id: number): Observable<string> {
    return this.http.post<string>(environment.apiUrl + `/uploads/${upload_id}/files/${file_id}/acknowledged`, {});
  }
  processed(upload_id: number, file_id: number): Observable<string> {
    return this.http.post<string>(environment.apiUrl + `/uploads/${upload_id}/files/${file_id}/processed`, {});
  }
  rejected(upload_id: number, rejectReq: any): Observable<string> {
    return this.http.post<string>(environment.apiUrl + `/uploads/${upload_id}/files/rejected`, rejectReq);
  }
  updateRejectComment(file_id: number, comment: string): Observable<string> {
    return this.http.post<string>(environment.apiUrl + `/update/${file_id}/rejectedcomment`, comment);
  }
  reset(upload_id: number, file_id: number): Observable<string> {
    return this.http.post<string>(environment.apiUrl + `/uploads/${upload_id}/files/${file_id}/reset`, {});
  }
  processAllFiles(upload_id: number, objectid: number,statusString: string): Observable<DraftsI> {
    return this.http.put<DraftsI>(environment.apiUrl + `/uploads/${objectid}/processed/${upload_id}/${statusString}`, {});
  }
  acknowledgeAllFiles(upload_id: number, objectid: number): Observable<string> {
    return this.http.put<string>(environment.apiUrl + `/uploads/${objectid}/acknowledged/${upload_id}`, {});
  }

  acknowledgeUploadAndFiles(uploadId: number, objectId: number): Observable<string> {
    const params =  new HttpParams().set('objectId', objectId ?? null);
    return this.http.put<string>(environment.apiUrl + `/uploads/${uploadId}/acknowledge-all`,null, {params});
  }

  resetAcknowledge(uploadId: number): Observable<string> {
    return this.http.put<string>(environment.apiUrl + `/uploads/reset-acknowledgement/${uploadId}`, {});
  }


  sendMails(payload: UploadObjectI): Observable<any> {
    return this.http.post<any>(environment.apiUrl + `/sendMail`, payload, { responseType: 'text' as 'json' });
  }
  deleteUpload(upload_id: number, objectid: number): Observable<string> {
    return this.http.put<string>(environment.apiUrl + `/uploads/${objectid}/delete/${upload_id}`, {});
  }
}
